import React from 'react';
import {
  formatRelativeTime,
  getPAMMStatusColor,
  capitalize,
} from '../../utils';

export interface TimelineEvent {
  id: string;
  title: string;
  description?: string;
  timestamp: string;
  status?: string;
  icon?: React.ReactNode;
  amount?: number | null;
}

interface TimelineProps {
  events: TimelineEvent[];
  className?: string;
}

export default function Timeline({ events, className = '' }: TimelineProps) {
  return (
    <div className={`relative space-y-0 ${className}`}>
      {/* Vertical line */}
      <div className="absolute left-4 top-0 bottom-0 w-px bg-border" />

      {events.map(event => (
        <div key={event.id} className="relative flex gap-4 pb-5 last:pb-0">
          {/* Dot */}
          <div className="relative z-10 flex-shrink-0 w-8 h-8 rounded-full bg-background border-2 border-border flex items-center justify-center">
            {event.icon ? (
              <span className="text-muted-foreground">{event.icon}</span>
            ) : (
              <div className="w-2 h-2 rounded-full bg-primary" />
            )}
          </div>

          {/* Content */}
          <div className="flex-1 min-w-0 pt-1">
            <div className="flex flex-wrap items-start justify-between gap-x-3 gap-y-1">
              <p className="text-sm font-medium text-foreground leading-snug">
                {event.title}
              </p>
              <span className="text-xs text-muted-foreground flex-shrink-0">
                {formatRelativeTime(event.timestamp)}
              </span>
            </div>
            {event.description && (
              <p className="text-xs text-muted-foreground mt-0.5 leading-relaxed">
                {event.description}
              </p>
            )}
            {event.status && (
              <span
                className={`inline-flex items-center mt-1.5 px-2 py-0.5 rounded-full text-xs font-medium border ${getPAMMStatusColor(event.status)}`}
              >
                {capitalize(event.status)}
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
